import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { ActivityListProps } from "./types"
import { ActivityItem } from "../activityItem"
import { NoResponse } from "../../../../../../../components/errors/noResponse"
import { ScrollContainer } from "../../../../../../../components/scrollContainer"
import { ActivityListHeader } from "../activityListHeader"
import Loader from "../../../../../../../components/loader"

export const MyActivityList = ({
  list,
  title,
  amount,
  id,
  arrayExpand,
  expandChild,
  usersToView,
  displayActivityListUsers,
  usersToDisplayed,
  menuOption,
  area,
  curp,
  deaprtment,
  division,
  role,
  listLocal,
  localLoad,
  types,
  assignData,
  modelStore,
}: ActivityListProps) => {
  const { t } = useTranslation()

  const normalizeId = (raw: any) => {
    const str = String(raw ?? "")
    const parts = str.split("-")
    return parts[parts.length - 1] || str
  }

  const modelStoreById = useMemo(() => {
    const map = new Map<string, any>()
    ;(modelStore ?? []).forEach((it: any) => {
      const key = normalizeId(it?.id)
      if (key) map.set(key, it)
    })
    return map
  }, [modelStore])

  return (
    <>
      {localLoad ? (
        <Loader />
      ) : (
        <ScrollContainer
          maxHeight="650px"
          showVerticalScroll
          sx={{
            width: "100%",
          }}
        >
          <ActivityListHeader
            area={area}
            curp={curp}
            department={deaprtment}
            division={division}
            rol={role}
            total={amount ?? 0}
            types={types}
            more={false}
          />

          {!listLocal?.length && <NoResponse label={t("general.noActivities")} />}

          {listLocal &&
            listLocal.map((userActivity: any) => {
              const key = normalizeId(userActivity?.id)
              const meta = modelStoreById.get(key)

              return (
                <ActivityItem
                  key={userActivity?.id}
                  menuOption={menuOption}
                  expandParent={arrayExpand?.find((item) => item.id === userActivity?.id)?.clave ?? false}
                  toggleExpand={expandChild}
                  assignData={assignData}
                  {...userActivity}
                  model={meta?.model ?? userActivity?.model}
                  modelId={meta?.modelId ?? userActivity?.modelId}
                  scheduledVisitId={meta?.scheduledVisitId ?? userActivity?.scheduledVisitId}
                  isVisible={!usersToDisplayed.some((user) => user == userActivity?.id)}
                  visibility={{
                    color: "primary",
                    onClick: (e) => {
                      e.stopPropagation()
                      displayActivityListUsers({ users: userActivity?.id })
                    },
                  }}
                />
              )
            })}
        </ScrollContainer>
      )}
    </>
  )
}
